module.exports = __webpack_public_path__ + "static/media/Trick_Em_Jigs_08_PREVIEW.bf52ca35.jpg";